<template>
  <div class="bg">
    <div class="part3">
      <div class="header-title">
        <div class="header-title-text">大赛资讯</div>
      </div>
      <div class="container">
        <div class="tabbar">
          <div
            :class="['item', itemIndex == 0 ? 'item-select' : '']"
            @click="changeTab('0')"
          >
            赛事影像
          </div>
          <div
            :class="['item', itemIndex == 1 ? 'item-select' : '']"
            @click="changeTab('1')"
          >
            赛事新闻
          </div>
        </div>
        <div class="content-view">
          <div class="more" @click="handleShowMore">查看更多>></div>
          <div class="news-list">
            <div class="left">
              <Part3Carousel :list="carouselList" />
            </div>
            <div class="right">
              <div
                v-for="(item, index) in list"
                :key="index"
                @click="handleShowDetail(item)"
              >
                <Part3Item
                  :cover-image="item.coverUrl"
                  :title="item.title"
                  :videoPath="item.path"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <el-button
        class="button"
        type="text"
        @click="handleShowMore"
      >查看更多</el-button> -->
    </div>
  </div>
</template>

<script>
import Part3Item from './Part3Item'
import Part3Carousel from './Part3Carousel.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Part3Item,
    Part3Carousel
  },
  props: {},
  data () {
    return {
      list: [],
      carouselList: [],
      itemIndex: 0
    }
  },
  computed: {
    ...mapState({
      device: (state) => state.app.device
    })
  },
  mounted () {
    this.itemIndex = '0'
    this.getList('ssyx')
  },

  methods: {
    handleShowMore () {
      this.$router.push({ path: '/dszx' })
    },
    handleShowDetail (item) {
      if (item.path) return
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    getList (path) {
      if (path === 'ssyx') {
        // 赛事影像
        var api =
          this.siteURL +
          '/actuator/article/selectArticleFile?siteId=' +
          this.siteId +
          '&nameEn=ssyx&pageNum=1&pageSize=11'
        this.axios.get(api, {}).then((response) => {
          this.list = response.data.rows.slice(5, 11)
          this.carouselList = response.data.rows.slice(0, 5)
        })
      } else {
        var url =
          this.siteURL +
          '/actuator/channel/list?siteId=' +
          this.siteId +
          '&url=/' +
          path
        this.axios.get(url, {}).then((response) => {
          this.channelId = response.data.rows[0].id
          var api =
            this.siteURL +
            '/actuator/article/indexList?channelId=' +
            this.channelId
          this.axios.get(api, {}).then((response) => {
            console.log('responseTzgg', response)
            this.list = response.data.rows.slice(5, 11)
            this.carouselList = response.data.rows.slice(0, 5)
          })
        })
      }
    },
    changeTab (index) {
      this.itemIndex = index
      let id = ''
      if (index === '0') {
        id = 'ssyx'
      } else {
        id = 'ssxw'
      }
      this.getList(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
}

.part3 {
  display: flex;
  flex-direction: column;
  padding: 20px 0 20px 0;
  align-items: center;
  width: 1140px;
  margin: auto;

  .header-title {
    width: 30%;
    margin: 0;
    height: 78px;
    background-image: url("~@/assets/images/title_bg.png");
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    &-text {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      text-align: right;
      font-style: normal;
      margin-left: 120px;
    }
  }

  .container {
    display: flex;
    height: 400px;
    width: 100%;
    padding: 0;
    background: linear-gradient(
      rgba(253, 254, 255, 0.49) 0%,
      rgba(255, 255, 255, 0.66) 100%
    );
    border-radius: 2px;
    border: 2px solid #ffffff;
    margin-top: 20px;
    flex-wrap: nowrap;
    background-position: center;
    background-size: 100% 100%;

    .tabbar {
      width: 180px;
      height: 396px;
      background-image: url("~@/assets/images/tabbarbg.png");
      background-size: 100% 100%;
      background-position: center;
      padding-top: 100px;

      .item {
        width: 180px;
        margin: auto;
        height: 98px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: MicrosoftYaHei;
        font-size: 24px;
        color: #343f51;
        cursor: pointer;
      }

      .item-select {
        background-image: url("~@/assets/images/tabitembg.png");
        background-size: 100% 100%;
        background-position: center;
        color: #00a1bb;
      }
    }

    .content-view {
      width: 100%;

      .more {
        font-family: MicrosoftYaHei;
        font-size: 18px;
        color: #0061ff;
        line-height: 24px;
        text-align: right;
        margin: 20px 20px 0 0;
        cursor: pointer;
      }

      .news-list {
        display: flex;

        .left {
          margin: 15px 0 0 20px;
        }

        .right {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          height: 280px;
          margin: 15px 0 0 20px;
        }
      }
    }
  }

  .button {
    width: 220px;
    height: 64px;
    opacity: 1;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;
    font-style: normal;
    border-radius: 32px;
    background: linear-gradient(#1065ff, #74a5ff);
  }
}

@media screen and (max-width: 767px) {
  .bg {
    background: url("");
    background-position: center;
    background-size: 100% 100%;
  }

  .part3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0;
    align-items: center;

    .header-title {
      width: 80%;
      margin: 0;
      height: 78px;
      background-image: url("~@/assets/images/title_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

      &-text {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        line-height: 55px;
        text-align: right;
        font-style: normal;
        margin-left: 120px;
      }
    }

    .container {
      display: block;
      height: auto;
      width: 101%;
      gap: 0px;
      background-image: "";
      background-position: center;
      background-size: 100% 100%;

      .tabbar {
        width: 100%;
        padding: 0;
        display: flex;
        height: auto;
      }

      .content-view {
        .news-list {
          width: 90%;

          .right {
            height: auto;
          }
        }
      }

      .left {
        margin: 0;
      }

      .right {
        display: block;
        flex-wrap: wrap;
        margin-top: 20px;
        height: auto;
        margin-top: 20px;
      }
    }

    .button {
      width: 220px;
      height: 64px;
      opacity: 1;
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #ffffff;
      line-height: 24px;
      font-style: normal;
      border-radius: 32px;
      background: linear-gradient(#1065ff, #74a5ff);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part3/Part3.vue